import { render, staticRenderFns } from "./manageCaisses.vue?vue&type=template&id=544f4016&scoped=true&class=mr-3&"
import script from "./manageCaisses.vue?vue&type=script&lang=js&"
export * from "./manageCaisses.vue?vue&type=script&lang=js&"
import style0 from "./manageCaisses.vue?vue&type=style&index=0&id=544f4016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f4016",
  null
  
)

export default component.exports